export const environment = {
  production: true,
  clientId: '0babd336-15b3-4a88-a63d-627774879ce9',
  tenantId: 'd145d1f9-d198-4bfc-963d-1ebccb89af5b',
  baseAddressAPI: 'https://salesfunction.azurewebsites.net',
  postLogoutUrl: 'https://sales.quotedevil.ie',
  code: 'Upm0qBkgEWAwKNU_4QNDTEbcRgnuZ-aLFijKXGxF7tn9AzFuZpMAYw==',
  brokerId: '04',
  onBoardingDocuments: {
    address: 'https://prod-onboardingfunctions.azurewebsites.net',
    code: 'bICjdJYoQF5VqWyIVX7xg6IIN8AjF9CAABLYmwonCZAhAzFucjMoBA==',
  },
  apiManagement: {
    address: 'https://apim-chill-motor-live.azure-api.net/gs/',
    scopes: ['api://e3154e6f-9cfd-4fa6-878a-a0737d94ac85/.default'],
    subscriptionKey: '57151aceecaa41c8b610c4b449b5bfb8'
  },
  onBoardingAPI: {
    address: 'https://url.chill.ie',
    subscriptionKey: '20e4a54121bf448da1cfbde6657889c0',
  }, hfqAPI: {
    address: 'https://ca-api-ingestion.graygrass-07cc9990.northeurope.azurecontainerapps.io/',
    subscriptionKey: 'f1a68d74173240cb857cbd7c281b5544',
  },rssAPI: {
    address: 'https://ca-api-ingestion.mangorock-d7e5eaf4.northeurope.azurecontainerapps.io/',
    uploadFunctionAPI: 'https://uploadlicences-live.azurewebsites.net/',
    uploadFunctionAPICode: 'Uv1YP0QOVw5xSV3YMZZKyfLrXh8E42I0gng6U570bw_6AzFuzL0_pA==',
      subscriptionKey: 'f1a68d74173240cb857cbd7c281b5544',
    },graphAPI: {
    address:
      'https://graph.microsoft.com/v1.0/groups/b5343b5d-81a2-4366-b798-44b6b6bbee6b/members',
  }
};
